import { render, staticRenderFns } from "./FixOrderRecoverItemPage.vue?vue&type=template&id=6d151f4d&scoped=true&"
import script from "./FixOrderRecoverItemPage.vue?vue&type=script&lang=ts&"
export * from "./FixOrderRecoverItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./FixOrderRecoverItemPage.vue?vue&type=style&index=0&id=6d151f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d151f4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VOverlay,VProgressCircular,VRow,VTextField})
